/**
 * Performs a word-based fuzzy search
 * Splits the search query into words and checks if all words appear at the beginning of words in the target
 * Words can appear in any order but must match at word boundaries
 *
 * @example
 * fuzzyMatch('bro gir', '2 Broke Girls') // returns true
 * fuzzyMatch('doc who', 'Doctor Who') // returns true
 * fuzzyMatch('game thro', 'Game of Thrones') // returns true
 * fuzzyMatch('hrones', 'Game of Thrones') // returns false (not at word start)
 */
export function fuzzyMatch(searchQuery: string, target: string): boolean {
  // Convert to lowercase for case-insensitive matching
  const query = searchQuery.toLowerCase().trim()
  const text = target.toLowerCase()

  // If query is empty, match everything
  if (!query) return true

  // Split query into individual words
  const searchWords = query.split(/\s+/).filter(word => word.length > 0)

  // Split target into words, handling punctuation as word boundaries
  const targetWords = text.split(/[\s.',-]+/).filter(word => word.length > 0)

  // Check if all search words match the beginning of any target word
  return searchWords.every(searchWord => {
    return targetWords.some(targetWord => targetWord.startsWith(searchWord))
  })
}
